'use client'
import { auth0UserQueryOptions } from '@/features/authentication/services/Authentication/queryOptions'
import { getAuth0Session } from '@/features/authentication/utils/authentication/session'
import { createPassiveQueryStore } from '@/features/shared/utils/dataFetching/createPassiveQueryStore'
import { useMemo } from 'react'

interface Auth0Session {
  userId: number
  sessionData: ReturnType<typeof useAuth0User>
  isSessionLoading: boolean
  isSessionValid: boolean
  isFullyAuthenticated: boolean
}

const useAuth0User = createPassiveQueryStore(() => auth0UserQueryOptions)

export const useSession = (): Auth0Session => {
  const auth0User = useAuth0User()

  return useMemo(() => getAuth0Session(auth0User), [auth0User])
}
